import React , { Component } from 'react';
import {BASE_URL} from "../../Config/SharedConfig";


class ProductCardVertical extends Component {
    render() {
        return(
            <div className={'product-card vertical row '+((!this.props.isActive||!this.props.isForShow) ? "inactive" : "")}>
                <div className='col-auto'>
                    <div className='img-cnt' style={{backgroundColor : this.props.dominantColor}}>
                        <img src={BASE_URL+this.props.thumbnail} alt='thumbnail' />
                        <div className="centered-text mobile-h5 desktop-h5 cl-white">
                            {
                                !this.props.isActive
                                    ? "غیرفعال"
                                    : !this.props.isForShow ? "ناموجود" : ""
                            }
                        </div>
                    </div>
                </div>
                <div className='col flex-grow-1'>
                    <div className='d-flex h-100 flex-column justify-content-between'>
                        <div>
                            <div className='title-box mobile-h5'>
                                { this.props.title }
                            </div>
                            <div className='description-box mobile-body-2-regular text-justified mt-custom-4'>
                                { this.props.description }
                            </div>
                        </div>
                        <div className='price-box'>
                            <div className='first-child align-items-center justify-content-end'>
                                <div className='mobile-h5 cl-black'>
                                    { this.props.price.toLocaleString() }
                                </div>
                                <div className='mobile-caption-strong cl-black '>
                                    تومان
                                </div>
                            </div>
                            <div className='second-child mobile-h5 desktop-h5 justify-content-end' style={{"color" : "#83868B"}}>
                                {
                                    !this.props.isActive
                                        ? "غیرفعال"
                                        : !this.props.isForShow ? "ناموجود" : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProductCardVertical